import { Result } from '../../../interfaces/Result';

/**
 * 文字列で受け取った判定結果から評価記号(A/B/C/D/-)のみを抽出する
 * 胃がんのように「C（B群）」といった形式で渡されるケースに対応する
 */
export const extractGrade = (result?: string): Result | undefined => {
  const grade = result?.trim().charAt(0);
  if (grade === 'A' || grade === 'B' || grade === 'C' || grade === 'D' || grade === '-') {
    return grade as Result;
  }
  return undefined;
};

export const normalizeResult = (result: string | null | undefined): Result => extractGrade(result ?? undefined) ?? 'A';
